<input class="form-check-input" type="checkbox" [(ngModel)]="value" (ngModelChange)="toggle.emit($event)" />
